import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatStrikethroughComponent } from "./med-icon-format-strikethrough.component";

@NgModule({
  declarations: [
    MedIconFormatStrikethroughComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatStrikethroughComponent,
  ],
})
export class MedIconFormatStrikethroughModule { }
